import { useContext } from 'react';
import AnswersContext from './answersContext';

const useAnswers = () => useContext(AnswersContext);

export default useAnswers;
